export enum ConfirmActionInputType {
  CONFIRM = 'CONFIRM',
  CANCEL = 'CANCEL',
  DISCARD = 'DISCARD',
}
